export default __webpack_public_path__ + "assets/tuto2.jpg";